import { render, staticRenderFns } from "./_head-view.vue?vue&type=template&id=48770872&scoped=true"
import script from "./_head-view.vue?vue&type=script&lang=js"
export * from "./_head-view.vue?vue&type=script&lang=js"
import style0 from "./_head-view.vue?vue&type=style&index=0&id=48770872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48770872",
  null
  
)

export default component.exports